import React, { useEffect, useState } from "react";
import Select from "react-select";
// import Creatable, { useCreatable } from 'react-select/creatable';
// import CreatableSelect from 'react-select/creatable';
// import { ActionMeta, OnChangeValue } from 'react-select';
// import SubHeader from '../../../../../component/common/layout/SubHeader'

import Header from "../../../../../component/common/layout/Header";
import Button from "../../../../../core/Button";
import Card from "../../../../../core/Card";
import Input from "../../../../../core/Inputs/DefaultInput";
import style from "../../../../style.module.css";
import Svg from "../../../../../component/common/Svg";
import { useDispatch, useSelector } from "react-redux";
import {
  addSurveyUrl,
  deleteSurveyUrl,
  getSurveyUrl,
  updateLinkStatus,
  updateSurveyUrl,
} from "../../../../../store/actions/urlAction";

import * as Yup from "yup";
import { useFormik } from "formik";
import { getTokenData } from "../../../../../store/actions/authAction";
import SurveyListSidebar from "../../../../../component/common/layout/SurveyListSidebar";
import { getUtmVariable } from "../../../../../store/actions/variableAction";
import Switch from "../../../../../core/Switch";
import { useMemo } from "react";
import DataTable from "react-data-table-component";
import { useVerifySurveyId } from "../../../../../hooks";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SURVEAY_URL = process.env.REACT_APP_USER_LINK;
const language_code = "22";

export default function Share() {
  //==> STATE <==

  //Modal
  const { t, i18n } = useTranslation();
  const [editMode, setEditMode] = useState(false);
  const [currentlyDeletingLink, setCurrentlyDeletingLink] = useState(null);
  const [currentLinkID, setCurrentLinkID] = useState(null);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [isNameError, setIsNameError] = useState(null);
  const [currentUrl, setCurrentUrl] = useState(null);
  const [modalTitle, setModalTitle] = useState("Build campaign URL");
  const [userId, setuserId] = useState("");
  const [btnText, setBtnText] = useState(t("survey.share.copy"));
  const [paramErrors, setParamErrors] = useState([
    {
      name: false,
      value: false,
    },
  ]);

  //Selector
  const urlData = useSelector((state) => state.urlData?.surveyUrlData);
  const urlDataLoading = useSelector(
    (state) => state.urlData?.getSurveyUrlDataLoading
  );
  const UtmCampainVariables = useSelector(
    (state) => state.variables?.utmVariableData
  );
  const { survey_name } = useSelector((state) => state.permissionsData);

  //Others
  const dispatch = useDispatch();
  const survey_id = useVerifySurveyId();

  //Columns
  const columns = [
    {
      name: t("survey.share.name"),
      cell: (row) => {
        return (
          <>
            <a
              href={getFinalLink(row)}
              className="linkedIn"
              target="_blank"
              rel="noreferrer"
            >
              <Svg name="link" />
              <span className="ms-2" title={row.link_name ?? ""}>
                {row.link_name ?? ""}
              </span>
            </a>
          </>
        );
      },
    },
    {
      name: t("survey.share.res"),
      selector: (row) => row.count ?? 0,
    },
    {
      name: t("survey.share.createdDate"),
      selector: (row) => {
        let date = new Date(row.add_date_time);
        return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
      },
    },
    {
      name: t("survey.share.status"),
      cell: (row, index) => {
        return (
          <>
            <div className="action-wrapper d-flex accordianSwitch" key={index}>
              <Switch
                type="dense"
                color="default"
                checked={Number(row.is_active) === 1}
                label={""}
                disabled={window.modulePermissions.M16.edit != 1}
                fill={false}
                rtl={false}
                leftPosition={false}
                className="SwitchCustom"
                value={row.survey_link_id}
                onChange={handleRequiredChange}
              />
            </div>
          </>
        );
      },
    },
    {
      name: t("survey.share.action"),
      cell: (row) => {
        return (
          <>
            <div className="d-flex">
              {window.modulePermissions.M16.edit == 1 && (<button
                title="Edit"
                className="action-btn"
                onClick={() => handleEdit(row)}
              >
                <Svg name="table-edit" />
              </button>)}
              <button
                title={t("survey.share.copy")}
                className="action-btn"
                onClick={() => copyFinalUrl(row)}
              >
                <Svg name="table-copy" />
              </button>
              {window.modulePermissions.M16.del == 1 && (<button
                title="Delete"
                className="action-btn"
                data-bs-toggle="modal"
                data-bs-target="#deleteLinkModal"
                onClick={() => setCurrentlyDeletingLink(row)}
              >
                <Svg name="table-delete" />
              </button>)}
            </div>
          </>
        );
      },
    },
  ];

  //==> FORM SCHEMA AND VALIDATION <==

  //Yup
  const formSchema = Yup.object().shape({
    linkName: Yup.string().trim().required("Link name required"),
    source: Yup.string().trim().required("Source required"),
    medium: Yup.string().trim().required("Medium required"),
    content: Yup.string().trim().required("Content required"),
    campaign: Yup.string().trim().required("Campaign required"),
  });

  //Formik
  const initialValues = {
    linkName: "",
    source: "",
    medium: "",
    content: "",
    campaign: "",
    params: [
      {
        name: "",
        value: "",
      },
    ],
    shortenLink: false,
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: formSchema,
    onSubmit: (data) => {
      if (editMode) {
        submitEditLink(data);
      } else {
        submitCreateLink(data);
      }
    },
  });

  const {
    values,
    handleChange,
    handleBlur,
    touched,
    errors,
    resetForm,
    setValues,
    setFieldValue,
    setFieldTouched,
    handleSubmit,
  } = formik;

  //==> FUNCTIONALITIES <==

  //Data handling
  const fetchUrl = () => {
    dispatch(getSurveyUrl(survey_id));
  };

  const resetModal = () => {
    setEditMode(false);
    setCurrentLinkID(null);
    setIsVisibleModal(false);
    setModalTitle("Build campaign URL");
    resetForm();
    setIsNameError(null);
    setFieldValue("params", [
      {
        name: "",
        value: "",
      },
    ]);
  };

  const validateParams = (paramsValues) => {
    let isValid = true;
    let errorMsgs = [];
    paramsValues?.length > 0 &&
      paramsValues.forEach((param, index) => {
        let err = { name: false, value: false };
        if (param.name === "") {
          err.name = true;
          isValid = false;
        }
        if (param.value === "") {
          err.value = true;
          isValid = false;
        }
        errorMsgs.push(err);
      });
    setParamErrors(errorMsgs);
    return isValid;
  };

  const setParamsValue = (index, key, value, paramsValues) => {
    let data = [...paramsValues];
    data[index][key] = value;
    setFieldValue("params", data);
  };

  const addParam = (index, paramsValues, e) => {
    e.preventDefault();
    if (!validateParams(paramsValues)) return;

    let data = [...paramsValues, { name: "", value: "" }];
    setFieldValue("params", data);
  };

  const removeParam = (index, paramsValues, e) => {
    e.preventDefault();
    let data = [...paramsValues];
    if (data.length > 1) {
      data.splice(index, 1);
      setFieldValue("params", data);
      // Remove the associated error message as well
      setParamErrors((prev) => {
        let copy = [...prev];
        copy.splice(index, 1);
        return copy;
      });
    }
  };

  const generateParams = (paramsArray) => {
    if (
      paramsArray.length === 1 &&
      (paramsArray[0].name === "" || paramsArray[0].value === "")
    ) {
      return "";
    }
    let rawParams = paramsArray?.map((param, index) => {
      if (paramsArray[index].name === "" || paramsArray[index].value === "") {
        return "";
      } else {
        return `${param.name}=${param.value}`;
      }
    });

    let params = rawParams.join("&");
    return `&${params}`;
  };

  const getUrl = (formValues) => {
    return `${SURVEAY_URL}/${survey_id}?utm_source=${
      formValues.source
    }&utm_medium=${formValues.medium}&utm_campaign=${
      formValues.campaign
    }&utm_content=${formValues.content}${generateParams(formValues.params)}`;
  };

  const getFinalLink = (linkData) => {
    const link = linkData.url;
    const lid = linkData.survey_link_id;
    return `${link}&lid=${lid}`;
  };

  const copyFinalUrl = (linkData) => {
    navigator?.clipboard
      ? navigator?.clipboard.writeText(getFinalLink(linkData))
      : unsecuredCopyToClipboard(linkData);
  };

  const unsecuredCopyToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("Unable to copy to clipboard", err);
    }
    document.body.removeChild(textArea);
  };

  //Action handling
  const handleEdit = (data) => {
    try {
      const url = new URL(data.url ?? "");
      const searchparams = new URLSearchParams(url.search);

      setModalTitle(t("survey.share.edit1"));
      setValues({
        linkName: data?.link_name,
        source: searchparams.get("utm_source"),
        medium: searchparams.get("utm_medium"),
        content: searchparams.get("utm_content"),
        campaign: searchparams.get("utm_campaign"),
        params: JSON.parse(data?.variables),
        shortenLink: false,
      });
    } catch (error) {
      console.error("URL parsing error");
    }

    setCurrentLinkID(data.survey_link_id);
    setEditMode(true);
    setIsVisibleModal(true);
  };

  const handleCopy = (link) => {
    navigator?.clipboard
      ? navigator?.clipboard.writeText(link)
      : unsecuredCopyToClipboard(link);
    setBtnText("Link copied");

    setTimeout(() => {
      setBtnText(t("survey.share.copy"));
    }, 700);
  };

  const handleDelete = ({ survey_link_id }) => {
    dispatch(deleteSurveyUrl(survey_link_id));
    setCurrentlyDeletingLink(null);
  };

  const handleRequiredChange = (e) => {
    const payload = {
      status: e.target.checked ? 1 : 0,
      survey_link_id: e.target.value,
    };
    dispatch(updateLinkStatus(payload));
  };

  //From submit
  const submitCreateLink = (data) => {
    const failCallback = (err) => {
      setIsNameError(err.name);
    };

    const successCallback = () => {
      fetchUrl();
      resetModal();
    };

    const payload = {
      survey_id: survey_id,
      name: values.linkName,
      variables: JSON.stringify(values.params),
      url: getUrl(data),
      added_by: userId,
    };
    // dispatch(addSurveyUrl(payload, resetModal, failCallback))
    // // setCurrentUrl(link)
    // fetchUrl()
    dispatch(addSurveyUrl(payload, successCallback, failCallback));
  };

  const submitEditLink = (data) => {
    const payload = {
      survey_link_id: currentLinkID,
      name: values.linkName,
      variables: JSON.stringify(values.params),
      url: getUrl(data),
    };
    dispatch(updateSurveyUrl(payload, resetModal));
    // setCurrentUrl(link)
    fetchUrl();
  };

  //==> EFFECTS <==
  useEffect(() => {
    fetchUrl();
    setCurrentUrl(`${SURVEAY_URL}/${survey_id}`);
  }, [survey_id]);

  useEffect(() => {
    dispatch(getTokenData(setuserId));
  }, [userId, dispatch]);

  useEffect(() => {
    dispatch(getUtmVariable(survey_id));
  }, [dispatch, isVisibleModal]);

  //==> Memos <==

  //Options
  const options = useMemo(() => {
    let sourceOptions = [],
      mediumOptions = [],
      campaignOptions = [];
    if (UtmCampainVariables) {
      UtmCampainVariables.forEach((variable) => {
        const type = variable.su_suv_type;
        const data = {
          value: variable.su_var_name,
          label: variable.su_var_name,
        };
        if (type === 1) {
          sourceOptions.push(data);
        } else if (type === 2) {
          mediumOptions.push(data);
        } else if (type === 3) {
          campaignOptions.push(data);
        }
      });
    }
    return {
      sourceOptions,
      mediumOptions,
      campaignOptions,
    };
  }, [UtmCampainVariables]);

  return (
    <>
      <div
        id="content"
        className="flex-grow-1 dashboard-page-outer d-flex flex-column bg-white"
      >
        <div className="share-page-padding dashboard-page-wrap">
          <div className="page-heading">
            {/* breadcrumbs here */}
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/survey/list">{t("survey.title")}</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{survey_name}</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <strong>{t("survey.share.tittle")}</strong>
                </li>
              </ol>
            </nav>
            {/* breadcrumbs ends here */}
            <h1>{t("survey.share.tittle")}</h1>
          </div>
          <h4>{t("survey.share.text1")}</h4>
          <div className="copy-link-wrapper d-flex mx-0">
            <div className="flex-grow-1">
              <Input
                type="text"
                view="outlined"
                color="default"
                label=""
                placeholder="https://Survey.io/stt-37980d5b56"
                // clearButton
                fill
                className={"formsinput" + " " + style.card__exp}
                value={currentUrl}
                readOnly
              />
            </div>
            <div className="button-wrapper ps-3">
              {/* <Link to="/OnBoardingScreen"> */}
              <Button
                className={"formsbutton"}
                type="default"
                view="filled"
                color="primary"
                text={btnText}
                fill={true}
                onClick={() => {
                  handleCopy(currentUrl);
                }}
              />
            </div>
          </div>
          <div className="table-wrap">
            <h4>{t("survey.share.campaign")}</h4>
            <div className="table-responsive">
              <div className="mb-4 custom-data-table">
                <DataTable
                  columns={columns}
                  data={urlData ?? []}
                  progressPending={urlDataLoading}
                  pagination
/>
              </div>
              {/* <table className="table mb-4">
                                    <thead>
                                        <tr>
                                            <th scope="col">Name</th>
                                            <th scope="col">Responses</th>
                                            <th scope="col">Created date</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {urlData?.length > 0 && urlData.map((surveyLink, index) => {
                                            let date = new Date(surveyLink.add_date_time)
                                            return (
                                                <tr key={index} onClick={() => setCurrentUrl(getFinalLink(surveyLink))}>
                                                    <td>
                                                        <a href={getFinalLink(surveyLink)} className="linkedIn" target='_blank'>
                                                            <Svg name="link" />
                                                            <span className="ms-2">{surveyLink.link_name}</span>
                                                        </a>
                                                    </td>
                                                    <td>{surveyLink.count ?? ''}</td>
                                                    <td>{`${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`}</td>
                                                    <td>
                                                        <div className="action-wrapper d-flex accordianSwitch">
                                                            < Switch
                                                                type='dense'
                                                                color='default'
                                                                checked={(Number(surveyLink.is_active) === 1)}
                                                                label={''}
                                                                disabled={false}
                                                                fill={false}
                                                                rtl={false}
                                                                leftPosition={false}
                                                                className='SwitchCustom'
                                                                value={surveyLink.survey_link_id}
                                                                onChange={handleRequiredChange}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex">
                                                            <button className='action-btn' onClick={() => handleEdit(surveyLink)}>
                                                                <Svg name="table-edit" />
                                                            </button>
                                                            <button className='action-btn' onClick={() => copyFinalUrl(surveyLink)}>
                                                                <Svg name="table-copy" />
                                                            </button>
                                                            <button className='action-btn' onClick={() => handleDelete(surveyLink)}>
                                                                <Svg name="table-delete" />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table> */}
            </div>
          </div>
          {window.modulePermissions.M16.add == 1 && (<div className="button-wrap create-url-btn text-center">
            <button
              className="btn btn-bordered"
              aria-expanded="false"
              onClick={() => setIsVisibleModal(true)}
            >
              {t("survey.share.create")}
            </button>
          </div>)}
        </div>

        <div
          className={`customvar-modal modal custom-modal fade url-build-modal ${
            isVisibleModal ? "show" : ""
          }`}
          style={{ display: `${isVisibleModal ? "block" : "none"}` }}
          id="urlBuildModal"
          tabIndex={-1}
          aria-labelledby="urlBuildModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-body">
                <div className={"formcontainer"}>
                  <form onSubmit={handleSubmit}>
                    <div className={"url-build-modal-wrapper"}>
                      <Card
                        view="raised"
                        className={"formstyle p-0 m-0" + " " + style.card}
                      >
                        <div className="heading">
                          <h4>{modalTitle}</h4>
                        </div>
                        <div className="form-wrapper">
                          <div className="description">
                            <p>{t("survey.share.text2")}</p>
                          </div>
                          <div className="form-fields-wrapper">
                            <div className="row mb-3">
                              <div className="col-md-2 text-md-end">
                                <label className="col-form-label">
                                  {t("survey.share.name")}
                                </label>
                              </div>
                              <div className="col-md-10">
                                <div className="position-relative">
                                  <Input
                                    type="text"
                                    view="outlined"
                                    color="default"
                                    label=""
                                    placeholder={t(
                                      "survey.customVariable.name"
                                    )}
                                    clearButton
                                    fill
                                    className={
                                      "formsinput" + " " + style.card__exp
                                    }
                                    value={values.linkName}
                                    name="linkName"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    onClear={() =>
                                      setFieldValue("linkName", "")
                                    }
                                  />
                                  {touched.linkName && errors.linkName && (
                                    <div className="validation-msg">
                                      {errors.linkName}
                                    </div>
                                  )}
                                  {isNameError && (
                                    <div className="validation-msg">
                                      {isNameError}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <div className="col-md-2 text-md-end">
                                <label className="col-form-label">
                                  {t("survey.share.source")}
                                </label>
                              </div>
                              <div className="col-md-10">
                                <div className="position-relative">
                                  <Select
                                    isClearable
                                    options={options.sourceOptions}
                                    name="source"
                                    value={
                                      options.sourceOptions?.filter(
                                        (opt) => opt.value === values.source
                                      )[0] ?? ""
                                    }
                                    onBlur={() => {
                                      setFieldTouched("source", true);
                                    }}
                                    onChange={(selectedOpt) => {
                                      setFieldValue(
                                        "source",
                                        selectedOpt?.value ?? ""
                                      );
                                    }}
                                  >
                                    {values.source}
                                  </Select>
                                  {touched.source && errors.source && (
                                    <div className="validation-msg">
                                      {errors.source}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <div className="col-md-2 text-md-end">
                                <label className="col-form-label">
                                  {t("survey.share.medium")}
                                </label>
                              </div>
                              <div className="col-md-10">
                                <div className="position-relative">
                                  <Select
                                    isClearable
                                    options={options.mediumOptions}
                                    name="medium"
                                    value={
                                      options.mediumOptions?.filter(
                                        (opt) => opt.value === values.medium
                                      )[0] ?? ""
                                    }
                                    onBlur={() => {
                                      setFieldTouched("medium", true);
                                    }}
                                    onChange={(selectedOpt) => {
                                      setFieldValue(
                                        "medium",
                                        selectedOpt?.value ?? ""
                                      );
                                    }}
                                  />
                                  {touched.medium && errors.medium && (
                                    <div className="validation-msg">
                                      {errors.medium}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <div className="col-md-2 text-md-end">
                                <label className="col-form-label">
                                  {t("survey.share.content")}
                                </label>
                              </div>
                              <div className="col-md-10">
                                <div className="position-relative">
                                  <Input
                                    type="text"
                                    view="outlined"
                                    color="default"
                                    label=""
                                    placeholder="Start Survey"
                                    clearButton
                                    fill
                                    className={
                                      "formsinput" + " " + style.card__exp
                                    }
                                    value={values.content}
                                    name="content"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    onClear={() => setFieldValue("content", "")}
                                  />
                                  {touched.content && errors.content && (
                                    <div className="validation-msg">
                                      {errors.content}
                                    </div>
                                  )}
                                </div>
                                <div className="help-text">
                                  Identifies what specifically was clicked to
                                  bring the user to the site, such as a banner
                                  ad or a text link. It is often used for A/B
                                  testing and content-targeted ads. Example
                                  utm_content=logolink or utm_content=textlink
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-2 text-md-end">
                                <label className="col-form-label">
                                  {t("survey.share.campaign")}
                                </label>
                              </div>
                              <div className="col-md-10">
                                <div className="position-relative">
                                  {/* <Input
                                                                    type="text"
                                                                    view="outlined"
                                                                    color="default"
                                                                    label=""
                                                                    placeholder="Marketing survey"
                                                                    clearButton
                                                                    fill
                                                                    className={"formsinput" + " " + style.card__exp}
                                                                    value={values.campaign}
                                                                    name="campaign"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    onClear={() => setFieldValue('campaign', '')}
                                                                /> */}
                                  <Select
                                    isClearable
                                    options={options.campaignOptions}
                                    name="campaign"
                                    value={
                                      options.campaignOptions?.filter(
                                        (opt) => opt.value === values.campaign
                                      )[0] ?? ""
                                    }
                                    onBlur={() => {
                                      setFieldTouched("campaign", true);
                                    }}
                                    onChange={(selectedOpt) => {
                                      setFieldValue(
                                        "campaign",
                                        selectedOpt?.value ?? ""
                                      );
                                    }}
                                  />
                                  {touched.campaign && errors.campaign && (
                                    <div className="validation-msg">
                                      {errors.campaign}
                                    </div>
                                  )}
                                </div>
                                <div className="help-text mb-3">
                                  {t("survey.share.text2")}
                                </div>
                                {/* <div className="parameter-add">
                                                            <a href="#" ><b>Add Parameter</b></a>
                                                        </div> */}
                                {/*Show Parameters once clicked on Add Button*/}
                                <div className="parameter-add-fields">
                                  <label htmlFor="">
                                    {t("survey.share.Parameters")}
                                  </label>
                                  {values.params?.length > 0 &&
                                    values.params?.map((param, index, arr) => {
                                      const isLast = index === arr.length - 1;
                                      return (
                                        <div className="d-flex" key={index}>
                                          <div className="flex-grow-1">
                                            <div className="row g-3">
                                              <div className="col-lg-6">
                                                <div className="mb-3 position-relative">
                                                  <Input
                                                    type="text"
                                                    view="outlined"
                                                    color="default"
                                                    label=""
                                                    placeholder={t(
                                                      "survey.customVariable.name"
                                                    )}
                                                    fill
                                                    className={"formsinput"}
                                                    value={param.name}
                                                    onChange={(e) =>
                                                      setParamsValue(
                                                        index,
                                                        "name",
                                                        e.target.value,
                                                        arr
                                                      )
                                                    }
                                                    onClear={() =>
                                                      setParamsValue(
                                                        index,
                                                        "name",
                                                        "",
                                                        arr
                                                      )
                                                    }
                                                  />
                                                  {paramErrors[index]?.name && (
                                                    <div className="validation-msg">
                                                      {t("survey.NRequired")}
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                              <div className="col-lg-6">
                                                <div className="mb-3 position-relative">
                                                  <Input
                                                    type="text"
                                                    view="outlined"
                                                    color="default"
                                                    label=""
                                      
                                                    fill
                                                    className={"formsinput"}
                                                    value={param.value}
                                                    onChange={(e) =>
                                                      setParamsValue(
                                                        index,
                                                        "value",
                                                        e.target.value,
                                                        arr
                                                      )
                                                    }
                                                    onClear={() =>
                                                      setParamsValue(
                                                        index,
                                                        "value",
                                                        "",
                                                        arr
                                                      )
                                                    }
                                                  />
                                                  {paramErrors[index]
                                                    ?.value && (
                                                    <div className="validation-msg">
                                                      Value required
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="button-wrap mb-3 d-flex align-items-center">
                                            {/* Always show Remove when there are multiple rows; Add only on last row */}
                                            {arr.length > 1 && (
                                              <button
                                                className="btn btn-link text-danger"
                                                style={{ marginRight: "5px" }}
                                                onClick={(e) =>
                                                  removeParam(index, arr, e)
                                                }
                                                type="button"
                                              >
                                                {t("webhook.remove") ||
                                                  "Remove"}
                                              </button>
                                            )}
                                            {isLast && (
                                              <button
                                                className="btn btn-link"
                                                onClick={(e) =>
                                                  addParam(index, arr, e)
                                                }
                                                type="button"
                                              >
                                                {t("survey.share.add")}
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="generated-url">
                          <div className="mb-3">
                            <label>{t("survey.share.url")}</label>
                            <textarea
                              className="form-control"
                              rows="2"
                              name="link"
                              value={getUrl(values)}
                              readOnly
                            ></textarea>
                          </div>

                          <div className="button-wrap d-flex justify-content-end">
                            {/* <button className="btn btn-primary" onClick={(e) => { e.preventDefault(); resetModal() }}>Cancel</button> */}
                            <button
                              type="button"
                              className="btn btn-bordered"
                              onClick={(e) => {
                                e.preventDefault();
                                resetModal();
                              }}
                            >
                              {t("survey.customVariable.cancel")}
                            </button>
                            {(editMode ? window.modulePermissions.M16.edit == 1 : true) && <button
                              type="submit"
                              className="btn btn-primary ms-3"
                            >
                              {editMode
                                ? t("survey.share.update")
                                : t("survey.builder.save")}
                            </button>}
                          </div>
                        </div>
                      </Card>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="customvar-modal modal custom-modal fade deleteModal"
          id="deleteLinkModal"
          tabIndex={-1}
          aria-labelledby="deleteModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className={"formcontainer" + " " + style.container}>
                  <div
                    className={
                      "formvawrapper delete-modal-wrap modal-sm" +
                      " " +
                      style.wrapper
                    }
                  >
                    <Card
                      view="raised"
                      className={"formstyle p-0" + " " + style.card}
                    >
                      <div className="delete-body-wrap delete-language">
                        <div className="heading">
                          <h3>{t("survey.customFormula.confirm_delete")}</h3>
                          <p>
                            {t("survey.share.del1")}
                            <strong>
                              {currentlyDeletingLink?.link_name ?? ""}
                            </strong>{" "}
                            {t("survey.customVariable.permanently")}
                          </p>
                        </div>

                        <div className="button-wrap d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-bordered"
                            data-bs-dismiss="modal"
                            onClick={() => setCurrentlyDeletingLink(null)}
                          >
                            {t("settings.roles.delete_action.cancel")}
                          </button>
                          {window.modulePermissions.M16.del == 1 && (<button
                            type="button"
                            className="btn btn-delete ms-3"
                            data-bs-dismiss="modal"
                            onClick={() => handleDelete(currentlyDeletingLink)}
                          >
                            {t("survey.customVariable.confirm_delete")}
                          </button>)}
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal-backdrop fade ${isVisibleModal ? "show" : ""}`}
          style={{ display: `${isVisibleModal ? "block" : "none"}` }}
        ></div>
      </div>
    </>
  );
}
